export default class EventEmitter {

  constructor() {
    this.events = {};
  }

  on(eventName, fn) {
    this.events[eventName] = this.events[eventName] || [];
    this.events[eventName].push(fn);
  }

  off(eventName, fn) {
    if (eventName in this.events === false) {
      return;
    }

    if (arguments.length === 1) {
      this.events[eventName] = [];
      return;
    }

    this.events[eventName] = _.without(this.events[eventName], fn);
  }

  trigger(eventName, ...args) {
    if (eventName in this.events === false) {
      return;
    }

    _.forEach(this.events[eventName], event => event.apply(this, args));
  }
}



// WEBPACK FOOTER //
// ./src/transport/utils/event-emitter.js